import { React, s } from 'Imports';
import { Outlet } from 'react-router-dom';
import { Drawer, Toolbar, styled } from 'MaterialUIComponents';
import theme from '$CSS/materialTheme';
import { paperClasses } from '@mui/material/Paper';
import { MainMenu } from '$Components/MainMenu';
import { getLogger } from '$Utilities/logging';
import { ConfigService } from '$State/ConfigFreezerService';
import logo = require('../../assets/logo.png');

const styles = require('Application.scss') as {
    active: string;
    link: string;
    logo: string;
    main: string;
    navbar: string;
    page: string;
    pageOuter: string;
    toolbar: string;
    content: string;
    vpLogoToolbar: string;
    contentToolbarPlaceholder: string;
    mainIntegrated: string;
};

const StyledDiv = styled('div')({
    ...theme.mixins.toolbar,
});

const logger = getLogger('Application');
const Layout = () => {
    logger.info('Rendering application layout');

    return (
        <>
            {ConfigService.isRunningStandAlone() ? (
                <Drawer
                    variant="permanent"
                    classes={{
                        paper: `${styles.navbar}`,
                    }}
                    sx={{ [`& .${paperClasses.root}`]: { position: 'relative', width: 305 } }}
                >
                    <Toolbar className={styles.vpLogoToolbar}>
                        <img className={styles.logo} src={logo} alt="Logo" />
                    </Toolbar>
                    {/* App Bar Placeholder */}
                    <StyledDiv className={styles.contentToolbarPlaceholder} />

                    <MainMenu />
                </Drawer>
            ) : null}
            <main className={styles.content} style={{ backgroundColor: theme.palette.background.default }}>
                {/* App Bar Placeholder */}
                <StyledDiv className={styles.contentToolbarPlaceholder} />

                <div className={styles.pageOuter}>
                    <div className={styles.page}>
                        <Outlet />
                    </div>
                </div>
            </main>
        </>
    );
};

export { Layout };
